<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center" v-if="checkPermission('AddIntervallePoids')">
        <a 
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#AddIntervallePoidsModal"
        >
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter un intervalle
        </a>
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Exporter
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>
      <div class="d-flex align-items-center">
        
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un intervalle"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <!-- <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> -->
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
              Type
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
              Début de l'intervalle 
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
              Fin de l'intervalle 
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(intervallePoids, index) in intervallePoidss" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ trouverType(intervallePoids.type) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
               {{ intervallePoids.debutIntervalle  }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ intervallePoids.finIntervalle }}
              </td>
              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('EditIntervallePoids')">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#AddIntervallePoidsModal"
                        @click="moddifier(intervallePoids)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier
                      </a>
                    </li>
                    <li v-if="checkPermission('DeleteIntervallePoids')">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" @click="suppression(intervallePoids.id,intervallePoidss,'intervallePoids','un intervalle de poids')"
                      >
                        <i
                          class="flaticon-delete lh-1 me-8 position-relative top-1" 
                        ></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
      
      <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        
      </div>
    </div>
  </div>
  <AddIntervallePoidsModal :item="selectedItem"   @close="recharger"/>
</template>
<script lang="ts">

import { defineComponent, onMounted, ref, watch, computed } from "vue";
import AddIntervallePoidsModal from "./AddIntervallePoidsModal.vue";
import ApiService from "../../services/ApiService";
import { format_date, suppression, error } from "../../utils/utils";
import {IntervallePoids} from '../../models/IntervallePoids';
import axios from 'axios';
import  Swal  from "sweetalert2";
import Paginate from 'vuejs-paginate'
import PaginationComponent from '../../components/Utilities/Pagination.vue';
import JwtService from "../../services/JwtService";

export default defineComponent({
    name: "ListeIntervallePoids",
    components: {
      AddIntervallePoidsModal,
      PaginationComponent
  },
  setup: () => {
    const modules = {
  
    };
    
    const intervallePoidss = ref<Array<IntervallePoids>>([]);
    const intervallePoids = ref<IntervallePoids>();
    const AddIntervallePoidsModalRef = ref<null | HTMLElement>(null);
    const selectedItem = ref(0);

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllIntervallePoidss(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher(){
      getAllIntervallePoidss(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getAllIntervallePoidss(page = 1, limi = 10, searchTerm = '') {
      // return ApiService.get('/intervallePoids')
      return ApiService.get(`intervallePoids?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      .then(({ data }) => {
        intervallePoidss.value = data.data.data;
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 
    // {
    //       value: 1 ,
    //       label: "Colis postaux"
    //   },
    //   {
    //       value: 2 ,
    //       label: "Envois express"
    //   },
    //   {
    //       value: 3 ,
    //       label: "Poste aux lettres"
    //   },
    //   {
    //       value: 4 ,
    //       label: "Transport de colis/marchandises et Location de bus/camions"
    //   }

    const trouverType = (value)=>{
      let type = '';
      switch (value) {
        case 1:
          type = "Colis postaux";
          break;
        case 2:
          type = "Envois express";
          break;
        case 3:
          type = "Poste aux lettres";
          break;
        case 4:
          type = "Transport de colis/marchandises et Location de bus/camions";
          break;
        default:
          type = '';
      }
      return type;
    }

    onMounted(() => {
      getAllIntervallePoidss();
    });

    function moddifier(EditIntervalle:IntervallePoids) {
      intervallePoids.value = EditIntervalle;
      selectedItem.value = EditIntervalle.id;
    }
    const recharger = () => {
      getAllIntervallePoidss();
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }


    return { modules,
      checkPermission,
            selectedItem,
            intervallePoidss,
            recharger,
            suppression, 
            moddifier, 
            page, 
            totalPages,
            limit,
            trouverType,
            totalElements,
            getAllIntervallePoidss,
            handlePaginate,
            searchTerm,
            rechercher,
            AddIntervallePoidsModalRef
    };
  },
});
</script>